export function generateRandomInteger(digits: number = 3): number {
    return Math.floor(Math.random() * Math.pow(10, digits));
}
